export default function ConcernExplorer({ concerns, onConcern }) {
  return (
    <section id="concerns" className="section concerns">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Start here</span>
          <h2>Explore by health concern</h2>
          <p>
            Tap any concern to learn about it, see helpful lifestyle tips, and find the natural products and care
            package best suited to it.
          </p>
        </div>
        <div className="concern-grid">
          {concerns.map((c) => (
            <div className="concern-card" key={c.id} onClick={() => onConcern(c.id)}>
              <div className="ic">
                <i className={`fa-solid ${c.icon}`} />
              </div>
              <h3>{c.title}</h3>
              <p>{c.short}</p>
              <div className="go">
                Learn more <i className="fa-solid fa-arrow-right" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
